import { render, staticRenderFns } from "./tijiaoshu.vue?vue&type=template&id=8109dbbe&scoped=true&"
import script from "./tijiaoshu.vue?vue&type=script&lang=js&"
export * from "./tijiaoshu.vue?vue&type=script&lang=js&"
import style0 from "./tijiaoshu.vue?vue&type=style&index=0&id=8109dbbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8109dbbe",
  null
  
)

export default component.exports